// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content_xYuGb","content_inverted":"content_inverted_Cvklz","content__row":"content__row_2kU0E","content__text":"content__text_1dT0U"};